import { editStorageObject } from "../../../../../app/state/storageObjectSlice/actions/actions";
import {
  getDialogMessagesAction,
  migrationToNewApiAction,
} from "../../../../../features/Dialog/redux/actions";
import {
  clearMessages,
  setDialogValue,
} from "../../../../../features/Dialog/redux/slice";
import type { DialogValue } from "../../../../api/instances/dialogApi/types";
import { deleteThread } from "../../../../api/instances/responseApi/api";
import type { ServiceHandler } from "./storageHandlers";

export const DialogsService: ServiceHandler = {
  async onCreate(listenerApi, normalized, meta) {
    if (normalized.value === null) {
      return;
    }
    try {
      const updatedValue: DialogValue = {
        dialog_object: {
          model: null,
          thread_ref: null,
          assistant_ref: null,
          messages: [],
        },
      };

      await listenerApi.dispatch(
        editStorageObject({
          id: normalized.id,
          name: normalized.friendly_name,
          value: updatedValue,
          service: meta.arg.service,
        }),
      );
      listenerApi.dispatch(setDialogValue(updatedValue));
    } catch (e) {
      console.error("Ошибка при создании диалога", e);
    }
  },
  async onSelect(listenerApi, id, value) {
    if (id === null || value === null) return;
    listenerApi.dispatch(setDialogValue(value as DialogValue));
    try {
      const thread_ref = (value as DialogValue)?.dialog_object?.thread_ref;
      listenerApi.dispatch(clearMessages());
      if (thread_ref) {
        listenerApi.dispatch(getDialogMessagesAction(thread_ref));
      } else if (
        (value as DialogValue)?.thread_id &&
        !(value as DialogValue)?.dialog_object
      ) {
        listenerApi.dispatch(
          migrationToNewApiAction({ value: value as DialogValue, id }),
        );
      }
    } catch (e) {
      console.error("Нет объекта с таким ID");
    }
  },
  async onDelete(listenerApi, id, value) {
    if (id === null || value === null) return;
    try {
      const thread_ref = (value as DialogValue)?.dialog_object?.thread_ref;
      if (thread_ref) {
        listenerApi.dispatch(clearMessages());
        await deleteThread(thread_ref);
      }
    } catch (e) {
      console.error("Нет объекта с таким ID");
    }
  },
};
